import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const TorontoMetropolitanUniversity = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="Toronto Metropolitan University (TMU)"
      universityShortName="TMU"
      slug="toronto-metropolitan-university"
      seoTitle="TMU Study Rooms | Toronto Metropolitan University Library Study Guide"
      seoDescription="Complete guide to study rooms at TMU (formerly Ryerson). Find quiet floors, group study rooms, and silent study areas. Plus free 24/7 online alternative."
      seoKeywords="tmu study rooms, toronto metropolitan university library, ryerson study rooms, tmu library, student learning centre, tmu quiet study"
      canonicalUrl="/study-room/toronto-metropolitan-university/"
      heroDescription="A comprehensive guide to study rooms and spaces at TMU's downtown campus, including the library's quiet floors and group study rooms."
      libraryWebsiteUrl="https://library.torontomu.ca/"
      libraryWebsiteName="TMU Library"
      studySpaces={[
        {
          name: "TMU Library - Floors 3, 6, 7, 9 (Quiet Study)",
          features: "Designated quiet study areas where low conversations are expected and silence is encouraged.",
          feedback: "Good for individual study when you need minimal distractions."
        },
        {
          name: "TMU Library - 10th Floor (Silent Study)",
          features: "Silent study floor where talking, whispering and phone use are prohibited.",
          feedback: "A noise policy warns that non-compliant students may be asked to leave. Some students complain the once-silent floor now resembles the Student Learning Centre with noise issues."
        },
        {
          name: "TMU Library - Floors 4-9 (Group Study)",
          features: "Support group study with low-level discussions. There is an open group study area on the 8th floor.",
          feedback: "Discussions must respect the quiet culture; groups need to keep voices low."
        },
        {
          name: "Bookable Group Study Rooms",
          features: "Rooms on floors 4-9 prioritize groups of three or more. Can be booked from 7 a.m. to 11:30 p.m. on weekdays and 10 a.m. to 11:30 p.m. on weekends. Rooms have screens, and HDMI adapters and markers can be borrowed.",
          feedback: "Walls are not fully sound-proofed so students are expected to keep voices low. During busy weeks, rooms book up quickly."
        },
        {
          name: "TMU Library - 2nd and 3rd Floors (Computers)",
          features: "Computer workstations concentrated on these floors for digital work.",
          feedback: "Can be busy during assignment deadlines and exam periods."
        }
      ]}
      guideContent={
        <>
          <p className="mb-4">
            TMU's library is structured like a vertical noise gradient: lower floors bustle with computers and group chatter, while the <strong>10th floor is intended to be silent</strong>. For deep focus, head straight to the 10th floor or the designated quiet floors—just be prepared to remind talkative peers of the rules.
          </p>
          <p className="mb-4">
            For small group meetings, <strong>booking a study room is essential</strong>; choose off-peak hours to secure a room, and keep voices soft because the walls are not completely sound-proof.
          </p>
          <p>
            When the library feels more like the Student Learning Centre (as some students lament), consider exploring quieter corners of <strong>Kerr Hall</strong> or <strong>Victoria Building</strong> for your next study session.
          </p>
        </>
      }
      summaryTips={[
        "Go to the 10th floor for silence: This is the designated silent floor, though enforcement varies.",
        "Book group rooms early: Rooms on floors 4-9 fill up quickly, especially during busy weeks.",
        "Keep voices low: Walls are not soundproof, so respect the quiet culture even in group rooms.",
        "Try alternative buildings: Kerr Hall and Victoria Building have quieter corners when the library is too noisy.",
        "Use CSW for reliable quiet: When the 10th floor gets noisy, virtual study rooms guarantee a distraction-free environment."
      ]}
    />
  );
};

export default TorontoMetropolitanUniversity;
